<template>
  <v-select
    :rules="rules"
    v-bind="fieldProps"
    :items="items"
    name="unit"
    label="Unidade"
  ></v-select>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    rules: [requiredValidation("Selecione sua unidade.")],
    items: [
      "SINOP FLORENÇA - FASIP/FASIPE",
      "SINOP AQUARELA - FASIP/FASIPE",
      "CUIABÁ - FASIPE CPA",
      "RONDONÓPOLIS - FASIPE RONDONÓPOLIS",
      "SORRISO - FASIPE SORRISO",
      "PRIMAVERA DO LESTE - FASIPE PRIMAVERA",
      "DISTRITO FEDERAL - FASIPE DISTRITO FEDERAL",
    ],
  }),
  mixins: [mixin],
};
</script>
